import { canonicalMoney, sumMoney, subtractMoney } from '../lib/money';

interface LedgerEntry {
  date: string;
  direction: string;
  entity_type: string;
  description: string;
  amount: number;
  payment_method: string | null;
}

const CATEGORY_MAP: Record<string, string> = {
  invoice: 'Client Payment',
  vendor_invoice: 'Vendor Payment',
  payroll: 'Payroll',
};

export function exportLedgerCSV(entries: LedgerEntry[], monthLabel: string) {
  const lines: string[] = [
    `"Payment Ledger — ${monthLabel}"`,
    '',
    'Date,Direction,Category,Description,Amount,Payment Method',
  ];

  for (const e of entries) {
    const cat = CATEGORY_MAP[e.entity_type] ?? e.entity_type;
    const dir = e.direction === 'in' ? 'Income' : 'Expense';
    lines.push(
      `${e.date},${dir},"${cat}","${e.description}",${e.direction === 'out' ? '-' : ''}${canonicalMoney(e.amount)},${e.payment_method ?? ''}`
    );
  }

  // Rule #34: canonical money sums through the wrapper.
  const totalIn = sumMoney(entries.filter(e => e.direction === 'in').map(e => canonicalMoney(e.amount)));
  const totalOut = sumMoney(entries.filter(e => e.direction === 'out').map(e => canonicalMoney(e.amount)));
  lines.push('');
  lines.push(`,,,"TOTAL INCOME",${totalIn},`);
  lines.push(`,,,"TOTAL EXPENSES",-${totalOut},`);
  lines.push(`,,,"NET",${subtractMoney(totalIn, totalOut)},`);

  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `payment-ledger-${monthLabel.replace(/\s/g, '-').toLowerCase()}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
